// Mirrors the server cap on every customer-facing tip path (operations `public-tip-amount.ts` MAX_TIP_CENTS).
export const MAX_TIP_CENTS = 1_000_000;
export const MAX_TIP_DOLLARS = MAX_TIP_CENTS / 100;
export const TIP_LIMIT_MESSAGE = 'Tips can be at most $10,000.00.';

export function isTipOverLimit(tipCents: number): boolean {
  return tipCents > MAX_TIP_CENTS;
}
